import React from "react";
import "./StatsCard.css";

const StatsCard = ({ label, value }) => (
  <div className="stats-card">
    <h3 className="stats-label">{label}</h3>
    <p className="stats-value">{value}</p>
  </div>
);

export default StatsCard;
